import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "custom-modal__space-between" }
const _hoisted_2 = { class: "custom-modal__space-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseHeading = _resolveComponent("BaseHeading")!
  const _component_BorderedInput = _resolveComponent("BorderedInput")!
  const _component_ControlButtons = _resolveComponent("ControlButtons")!
  const _component_CustomModal = _resolveComponent("CustomModal")!

  return (_openBlock(), _createBlock(_component_CustomModal, {
    id: `m-create-epic_${_ctx.id}`,
    modalClass: "custom-modal_margin-custom custom-modal_delete-modal",
    width: "512",
    onOnBeforeOpen: _ctx.clearInput
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_BaseHeading, {
            level: "3",
            color: "monochrome-06"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Create New Epic ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    body: _withCtx(({ validators }) => [
      _createElementVNode("form", {
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createVNode(_component_BorderedInput, {
          id: "newEpicName",
          modelValue: _ctx.newEpicName,
          placeholder: "Epic Name",
          validateOnChange: false,
          rules: validators.isRequiredAndValid({ resourceTypes: 'EPIC', projectId: _ctx.projectId }, 'Epic Name'),
          maxLength: _ctx.TITLE_MAX_LENGTH,
          focus: true,
          "onUpdate:modelValue": _ctx.handleInput,
          onEnter: _ctx.onCreateEpic
        }, null, 8, ["modelValue", "rules", "maxLength", "onUpdate:modelValue", "onEnter"])
      ], 32)
    ]),
    footer: _withCtx(({ hide, validate }) => [
      _createVNode(_component_ControlButtons, {
        onSave: ($event: any) => (_ctx.onCreateEpic(validate)),
        onCancel: hide
      }, {
        save: _withCtx(() => [
          _createTextVNode(" Create Epic ")
        ]),
        _: 2
      }, 1032, ["onSave", "onCancel"])
    ]),
    _: 1
  }, 8, ["id", "onOnBeforeOpen"]))
}